module.exports = __webpack_public_path__ + "img/account.rate.monthly.573d203a.png";